import { render, staticRenderFns } from "./SimpleCategoryWidget.vue?vue&type=template&id=0c75116e&lang=pug&"
import script from "./SimpleCategoryWidget.vue?vue&type=script&lang=js&"
export * from "./SimpleCategoryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports